var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/UserClassifierRepo/DynamicGroup/DynamicGroupStatus.ts";
import * as t from 'io-ts';
import { Id } from '../../Id';
import { Version } from '../../Version';
export var DynamicGroupStatus;

(function (_DynamicGroupStatus) {
  var Status = t.union([t.literal('NotStarted'), t.literal('Started'), t.literal('InProgress'), t.literal('Finished'), t.literal('Error'), t.literal('ErrorTimedOut')]);
  var Data = _DynamicGroupStatus.Data = t.type({
    status: Status,
    classifierId: Id,
    classifierVersion: Version
  });
})(DynamicGroupStatus || (DynamicGroupStatus = {}));